import { render, staticRenderFns } from "./MenuCategories.vue?vue&type=template&id=f6850a86&scoped=true"
import script from "./MenuCategories.vue?vue&type=script&lang=js"
export * from "./MenuCategories.vue?vue&type=script&lang=js"
import style0 from "./MenuCategories.vue?vue&type=style&index=0&id=f6850a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6850a86",
  null
  
)

export default component.exports